// LocalStorage alternative for when LocalStorage is not available
const storage = {};
function MemoryStorage (id) {
  id = id || 'global';

  // return existing instance
  if (storage[id]) {
    return storage[id];
  }

  if (!(this instanceof MemoryStorage)) {
    return new MemoryStorage(id);
  }

  // create and store a new instance
  const instance = storage[id] = this;
  // holds storage data
  const data = {};

  Object.defineProperties(instance, {
    id: {
      value: id,
      enumerable: true,
      configurable: true
    },
    length: {
      enumerable: true,
      configurable: true,
      get () {
        return Object.keys(data).length;
      }
    },
    ownKeys: {
      enumerable: false,
      configurable: true,
      get () {
        return Object.keys(data);
      }
    }
  });

  // retrieve an item from storage
  instance.getItem = function MemoryStorage_getItem (key) {
    return data[key] || null;
  };

  // set an item in storage
  instance.setItem = function MemoryStorage_setItem (key, val) {
    data[key] = val;
  };

  // remove item from storage
  instance.removeItem = function MemoryStorage_removeItem (key) {
    delete data[key];
  };

  // retrieve key but index
  instance.key = function MemoryStorage_key (idx) {
    const keys = Object.keys(data);
    return idx >= 0 && idx < keys.length ? keys[idx] : null;
  };

  // clear storage
  instance.clear = function MemoryStorage_clear () {
    const keys = Object.keys(data);
    for (let key of keys) {
      delete data[key];
    }
  };
}

// if localStorage is unavailable then use MemoryStorage
export default (function () {
  try {
    if ('localStorage' in window && window.localStorage !== null) {
      return window.localStorage;
    }
  } catch (e) {
    return new MemoryStorage();
  }
})();
